<template>
<div id="puzzle-calendar">
  <div
    class="form-group"
  >
    <label for="date">
      Choose a date to see available puzzles:
    </label>

    <input
      type="date"
      name="date"
      id="date"
      class="form-control"
      v-model="date"
      v-on:change="get"
    />
  </div>
  <div
    class="form-group"
    v-if="date"
  >
    <hr />

    <h3>Puzzles For '{{ date }}'</h3>

    <pagination
      :resourceUrl="resourceUrl"
      :pageResponse="pageResponse"
      :pageSize="$root.defaultPageSize"
      orderBy="date"
      orderType="DESC"
      v-if="resourceUrl"
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <puzzle-list-item :puzzle="item" />
      </template>
    </pagination>
  </div>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import PuzzleListItem from '@/components/PuzzleListItem'

export default {
  data () {
    return {
      date: undefined,
      pageResponse: {},
      puzzles: []
    }
  },

  computed: {
    resourceUrl () {
      return this.apiUrl('/puzzles/' + this.date + '/puzzle_list_by_date')
    }
  },

  components: {
    'pagination': Pagination,
    'puzzle-list-item': PuzzleListItem
  },

  methods: {
    get () {
      this.$http.get(this.resourceUrl).then((resp) => {
        this.pageResponse = resp
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PuzzleCalendar.vue